import styled from "styled-components";

export const Container = styled.div`
  padding-top: 16px;
  padding-bottom: 32px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;

  h1 {
    color: #2d2d2d;
    text-align: center;
    font-family: Mulish;
    font-size: 20px;
    font-style: normal;
    font-weight: 800;
    line-height: 24px;
    margin-bottom: 32px;
  }

  @media (min-width: 640px) {
    padding-top: 120px;
  }
`;

export const WrapperFilter = styled.div`
  margin-bottom: 32px;

  > button {
    margin: 0 auto 32px auto;
  }

  @media (min-width: 640px) {
    > button {
      margin: 0 0 32px;
    }
  }
`;

export const ReportFilter = styled.form`
  padding: 36px 12px;
  border-radius: 10px;
  border: 1px solid #9d9d9d;
  background: #fff;
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin-bottom: 32px;
  width: 100%;
  max-width: 980px;

  > div:last-child {
    display: flex;
    gap: 32px;
    justify-content: center;
    align-items: center;
  }

  @media (min-width: 640px) {
    padding: 32px;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
  }
`;

export const WrapperGridItems = styled.div`
  > div + div {
    margin-top: 32px;
  }

  > div:nth-child(odd) {
    background: #e8e8e8;
  }
  > div:nth-child(even) {
    background: #f7f7f7;
  }
`;

export const GridItem = styled.div`
  border-radius: 5px;
  padding: 8px 12px;
  display: flex;
  justify-content: space-between;

  img {
    cursor: pointer;
  }

  @media (min-width: 640px) {
    padding: 20px;

    img {
      margin-left: 32px;
    }
  }
`;

export const GridItemContent = styled.div`
  > p {
    color: #2d2d2d;
    font-family: Mulish;
    font-size: 12px;
    font-style: normal;
    font-weight: 800;
    line-height: 24px;
    letter-spacing: 0.36px;
    text-transform: uppercase;

    > span {
      font-weight: 400;
    }
  }

  @media (min-width: 640px) {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
`;

export const WrapperPagination = styled.div`
  margin: 32px 0;
`;

export const ToBack = styled.button`
  color: #2d2d2d;
  display: block;
  width: fit-content;
  text-align: center;
  font-family: Mulish;
  background-color: transparent;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  text-decoration-line: underline;
  margin: 0 auto;
`;
